import Auth from '../../modules/Authentication'
import {apiUrl} from '../../variables'
import {handleErrors, handleResponse} from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const VehiclesApi = {
  list: project => {
    const type = 'vehicles'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}resources/?select=*` +
        (type ? `&type=${type || ''}` : '') +
        (project ? `&project=${project || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    data.type = 'vehicles'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
export const DriversApi = {
  list: (project, type = 'drivers') => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}resources/?select=*` +
        (type ? `&type=${type || ''}` : '') +
        (project ? `&project=${project || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    data.type = 'drivers'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
export const VendorsApi = {
  list: (project, type = 'vendors') => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}resources/?select=*` +
        (type ? `&type=${type || ''}` : '') +
        (project ? `&project=${project || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    data.type = 'vendors'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
export const DepartmentsApi = {
  list: (project, type = 'departments') => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}resources/?select=*` +
        (type ? `&type=${type || ''}` : '') +
        (project ? `&project=${project || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    data.type = 'departments'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
export const FuelTokensApi = {
  list: (project, type = 'fuelTokens') => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(
      `${apiUrl}resources/?select=*` +
        (type ? `&type=${type || ''}` : '') +
        (project ? `&project=${project || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    data.type = 'fuelTokens'
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}resources/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
}
export const remove = data => {
  headers['authorization'] = `Bearer ${auth.getAccessToken()}`
  return fetch(`${apiUrl}resources/`, {
    headers: headers,
    method: 'DELETE',
    body: JSON.stringify(data),
  }).then(handleErrors)
}
